/* eslint-disable @typescript-eslint/no-explicit-any */
/* eslint-disable @typescript-eslint/ban-ts-comment */
import { Link } from "react-router-dom";
import Chevron from "../components/Icons/Chevron";
import { useParams, useNavigate } from "react-router-dom";
import { GetLectureById } from "../api/Lecture/GetLecturerById";
import { useMutation, useQuery } from "@tanstack/react-query";
import DurationIcon from "../components/Icons/DurationIcon";
import ContentAccordion from "../components/CoursePage/ContentAccordion";
import Spinner from "../components/Shared/Spinner";
import { Disclosure, Transition } from "@headlessui/react";
import { useEffect, useState } from "react";
import { Accordion } from "../components/Shared/accordion";
import Video2Icon from "../components/Icons/Video2Icon";
import CertificateIcon from "../components/Icons/CertificateIcon";
import VerifyIcon from "../components/Icons/VerifyIcon";
// import VPlayer from "vnetwork-player";
import Button from "../components/Shared/Button";
import EyeFill from "../components/Icons/EyeFill";
import { AddVideoProgress } from "../api/Courses/VideoProgress";
import { queryClient } from "../main";
import { toast } from "react-toastify";
import { GetProgress } from "../api/Courses/GetProgress";
import { ApiError } from "../types/ApiError";
import { GetStudentAnswers } from "../api/Quiz/GetStudentAnswers";
import SadFaceIcon from "../components/Icons/SadFaceIcon";
import { GetEssayAnswers } from "../api/Quiz/GetEssayAnswers";
import { GetExamAnswers } from "../api/Quiz/GetExamAnswers";
import TextArea from "../components/Shared/TextArea";
import { SendFeedback } from "../api/Courses/SendFeedback";
import { ButtonTypes } from "../utils/consts";
import CertificateIcon2 from "../components/Icons/CertificateIcon2";
import {
  CertificateResponse,
  CreateCertificate,
} from "../api/Students/CreateCertificate";
import { useUserDataStore } from "../stores/user";
import { useCertificateStore } from "../stores/certificateStore";

import { Helmet } from "react-helmet";
import { formatDuration } from "../hooks/DurationConverter";

const Lecture = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const lectureId = id || "";
  const [currentVideoUrl, setCurrentVideoUrl] = useState("");
  const [currentVideoId, setCurrentVideoId] = useState("");
  const [currentVideoName, setCurrentVideoName] = useState("");
  const [lastVideoName, setLastVideoName] = useState("");
  const [currentQuizId, setCurrentQuizId] = useState("");
  const [currentQuizName, setCurrentQuizName] = useState("");
  const [currentEssayId, setCurrentEssayId] = useState("");
  const [currentEssayName, setCurrentEssayName] = useState("");
  const [currentExamId, setCurrentExamId] = useState("");
  const [currentExamMCQId, setCurrentExamMCQId] = useState("");
  const [currentExamName, setCurrentExamName] = useState("");
  const [currentVideoOTP, setCurrentVideoOTP] = useState("");
  const [currentVideoPlayback, setCurrentVideoPlayback] = useState("");

  const [feedbackMessage, setFeedbackMessage] = useState("");
  const { userData } = useUserDataStore();
  const { setCertificateData } = useCertificateStore();
  useEffect(() => {
    if (currentVideoId !== "") {
      setCurrentQuizId("");
      setCurrentEssayId("");
      setCurrentExamId("");
      setCurrentExamMCQId("");
    }
  }, [currentVideoId]);

  const { mutate } = useMutation({
    mutationFn: () => AddVideoProgress(currentVideoId),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["lecture"] });
      queryClient.invalidateQueries({ queryKey: ["progress"] });
      toast("🔥 Video watched successfully");
    },
    onError: (error: unknown) => {
      const apiError = error as ApiError;
      if (apiError.statusCode === 400) {
        toast.error(apiError.message);
      } else {
        toast.error("Error Watching Video");
      }
    },
  });

  const { mutate: mutateFeedback } = useMutation({
    mutationFn: SendFeedback,
    onSuccess: () => {
      toast("Feedback sent successfully");
      queryClient.invalidateQueries({ queryKey: ["feedback"] });
      setFeedbackMessage("");
    },
    onError: () => {
      toast.error("Error sending feedback");
    },
  });

  const { mutate: mutateCertificate } = useMutation({
    mutationFn: CreateCertificate,
    onSuccess: (response: CertificateResponse) => {
      //@ts-expect-error
      setCertificateData(response.data);
      navigate("/certificate");
      toast("Certificate request sent successfully");
    },
    onError: () => {
      toast.error("Error requesting certificate");
    },
  });

  const { data: LectureByIdDTO, isLoading: isLectureLoading } = useQuery({
    queryFn: () => GetLectureById(lectureId),
    queryKey: ["lecture", lectureId],
    staleTime: 0,
    refetchInterval: 0,
    refetchOnWindowFocus: false,
  });

  const Lecture = LectureByIdDTO?.data;
  const CourseId = Lecture?.course?.id || "";
  const { data: ProgressDTO, isLoading: isProgressLoading } = useQuery({
    queryFn: () => GetProgress(CourseId),
    queryKey: ["progress", CourseId],
    staleTime: 0,
    refetchInterval: 0,
    refetchOnWindowFocus: false,
  });

  const { data: StudentAnswers, isLoading: isAnswersLoading } = useQuery({
    queryFn: () => GetStudentAnswers(currentQuizId),
    queryKey: ["answers", currentQuizId],
    staleTime: 0,
    refetchInterval: 0,
    enabled: !!currentQuizId,
    refetchOnWindowFocus: false,
  });
  const { data: EssayAnswers, isLoading: isEssayAnswersLoading } = useQuery({
    queryFn: () => GetEssayAnswers(currentEssayId),
    queryKey: ["answers", currentEssayId],
    staleTime: 0,
    refetchInterval: 0,
    enabled: !!currentEssayId,
    refetchOnWindowFocus: false,
  });
  const { data: ExamAnswers, isLoading: isExamAnswersLoading } = useQuery({
    queryFn: () => GetExamAnswers(currentExamId),
    queryKey: ["answers", currentExamId],
    staleTime: 0,
    refetchInterval: 0,
    enabled: !!currentExamId,
    refetchOnWindowFocus: false,
  });

  const studentAnswers = StudentAnswers?.data;
  const essayAnswers = EssayAnswers?.data;
  const examAnswers = ExamAnswers?.data;
  const Progress = ProgressDTO?.data?.progressData;
  useEffect(() => {
    //@ts-expect-error
    if (Lecture?.videos?.length > 0) {
      const lastVideo = Lecture?.videos.find((video) => video.last === true) ||
        Lecture?.videos[0] || {
          url: "",
          id: "",
          cipher: { otp: "", playbackInfo: "" },
          name: "",
        };
      setCurrentVideoUrl(lastVideo.url);
      setCurrentVideoId(lastVideo.id);
      setCurrentVideoOTP(lastVideo.cipher.otp);
      setLastVideoName(lastVideo.name);
      setCurrentVideoPlayback(lastVideo.cipher.playbackInfo);
    }
  }, [Lecture]);
  const handleLectureClick = (newLectureId: string) => {
    navigate(`/lecture/${Lecture?.course.id}/${newLectureId}`, {
      replace: true,
    });
  };

  const handleVideoSelect = (
    url: string,
    id: string,
    otp: string,
    playback: string,
    name: string
  ) => {
    setCurrentVideoUrl(url);
    setCurrentVideoId(id);
    setCurrentVideoPlayback(playback);
    setCurrentVideoOTP(otp);
    setCurrentVideoName(name);
    setCurrentQuizId("");
    setCurrentQuizName("");
    setCurrentEssayId("");
    setCurrentEssayName("");
    setCurrentExamName("");
    setCurrentExamId("");
    setCurrentExamMCQId("");
  };

  const handleQuizSelect = (id: string, name: string) => {
    setCurrentQuizName(name);
    setCurrentQuizId(id);
    setCurrentVideoUrl("");
    setCurrentVideoId("");
    setCurrentEssayId("");
    setCurrentEssayName("");
    setCurrentExamName("");
    setCurrentExamId("");
    setCurrentVideoPlayback("");
    setCurrentVideoOTP("");
    setCurrentVideoName("");
    setCurrentExamMCQId("");
  };
  const handleExamSelect = (id: string, name: string, mcqId: string) => {
    setCurrentExamName(name);
    setCurrentExamId(id);
    setCurrentExamMCQId(mcqId);
    setCurrentQuizName("");
    setCurrentQuizId("");
    setCurrentVideoUrl("");
    setCurrentVideoId("");
    setCurrentEssayId("");
    setCurrentEssayName("");
    setCurrentVideoPlayback("");
    setCurrentVideoOTP("");
    setCurrentVideoName("");
  };

  const handleEssaySelect = (id: string, name: string) => {
    setCurrentEssayName(name);
    setCurrentEssayId(id);
    setCurrentVideoUrl("");
    setCurrentVideoId("");
    setCurrentQuizId("");
    setCurrentQuizName("");
    setCurrentExamName("");
    setCurrentExamId("");
    setCurrentVideoPlayback("");
    setCurrentVideoOTP("");
    setCurrentVideoName("");
    setCurrentExamMCQId("");
  };

  const handleFeedbackSubmit = (e: React.FormEvent) => {
    e.preventDefault();
    const payload = {
      videoId: currentVideoId,
      message: feedbackMessage,
    };
    mutateFeedback(payload);
  };

  const handleGetCertified = () => {
    const payload = {
      studentId: userData?.id || "",
      courseId: CourseId,
      instructorId: Lecture?.instructor.id || "",
    };
    mutateCertificate(payload);
  };

  useEffect(() => {
    const handleContextMenu = (e: Event) => {
      e.preventDefault();
    };

    document.addEventListener("contextmenu", handleContextMenu);

    return () => {
      document.removeEventListener("contextmenu", handleContextMenu);
    };
  }, []);
  const calculateTotalDuration = (chapters: any[]) => {
    let totalDurationInSeconds = 0;

    chapters.forEach((chapter) => {
      chapter?.lectures?.forEach((lecture: { duration: number }) => {
        totalDurationInSeconds += lecture?.duration;
      });
    });

    return totalDurationInSeconds;
  };

  if (isLectureLoading)
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner />
      </div>
    );
  if (!Lecture) {
    return (
      <div className="min-h-screen flex items-center justify-center">
        <Spinner />
      </div>
    );
  }

  const totalModules = Lecture?.chapter?.length || 0;
  const totalLectures =
    Lecture?.chapter?.reduce(
      (acc, chapter) => acc + chapter?.lectures?.length,
      0
    ) || 0;

  const activeLectureItemId = `lecture-${Lecture?.chapter?.findIndex(
    (ch) => ch.id === Lecture?.chapterId
  )}-${Lecture?.chapter
    .find((ch) => ch.id === Lecture?.chapterId)
    ?.lectures?.findIndex((lec) => lec.id === lectureId)}`;

  const totalDurationInSeconds = calculateTotalDuration(Lecture?.chapter);
  const formattedDuration = formatDuration(totalDurationInSeconds);

  return (
    <div className="xl:pt-40 lg:pt-48 md:pt-52 pt-32 pb-36">
      <Helmet>
        <link
          rel="canonical"
          href={`https://www.nilewisect.com/lecture/${Lecture?.title}`}
        />
      </Helmet>

      <div className="container pt-16 mt-0.5">
        {Number(Progress?.percentage) === 100 && (
          <div className="bg-primary sm:px-10 px-4 sm:py-6 py-4 rounded-lg bg-no-repeat bg-cover bg-heroBg w-full text-white flex justify-between items-center mb-8 gap-6 md:flex-row flex-col">
            <div className="sm:flex sm:gap-5 gap-2">
              <CertificateIcon2 className="text-secondary sm:min-w-[60px] sm:min-h-[60px] sm:h-[60px] sm:w-[60px] min-w-12 min-h-12 w-12 h-12 mx-auto sm:mx-0" />
              <div>
                <h1 className="font-bold sm:text-2xl leading-0  text-lg mb-1 sm:text-start text-center">
                  You're ready to get{" "}
                  <span className="text-secondary">Certified!</span>
                </h1>
                <p className="sm:text-base text-sm font-medium max-w-[811px]  text-white/80  sm:text-start text-center">
                  Elevate your career and prove your skills with AAA
                  Certification: Recognized industry-wide, begin now.
                </p>
              </div>
            </div>
            <Button
              variant="secondary"
              className="md:min-w-[162px] md:w-auto w-full text-xs font-semibold sm:h-9 h-8 rounded-lg"
              onClick={handleGetCertified}
            >
              {" "}
              Get Certification
            </Button>
          </div>
        )}
        <div className="flex justify-between flex-col lg:flex-row gap-6">
          <div className="lg:max-w-[800px] w-full">
            <div className="flex sm:gap-2 gap-0.5 items-start sm:mb-6 mb-3">
              <div className="sm:w-2 w-1.5 sm:min-h-[64px] min-h-[42px] rounded-2xl bg-primary mr-1"></div>
              <div className="flex items-center my-auto sm:gap-2 gap-0.5 flex-wrap">
                <Link
                  to={`/course/${Lecture?.course.id}`}
                  className="flex items-center gap-0.5 text-burntBlack/85 font-medium sm:text-lg text-sm -tracking-[0.02em] cursor-pointer "
                >
                  Course <Chevron className="sm:size-auto size-4" />
                </Link>
                <div className="flex items-center gap-0.5 text-burntBlack font-semibold sm:text-lg text-sm -tracking-[0.02em] cursor-pointer">
                  {Lecture?.course.name}{" "}
                  <Chevron className="sm:size-auto size-4" />
                </div>
                <div className="flex items-center gap-0.5 text-burntBlack font-semibold sm:text-lg text-sm -tracking-[0.02em] cursor-pointer">
                  {Lecture?.title} <Chevron className="sm:size-auto size-4" />
                </div>
                <div className="flex items-center gap-0.5 text-burntBlack font-semibold sm:text-lg text-sm -tracking-[0.02em] cursor-pointer">
                  {Lecture?.videos && <>{currentVideoName || lastVideoName}</>}
                </div>
              </div>
            </div>
            <div className="sm:mb-10 mb-11 pb-0.5 rounded-xl overflow-hidden">
              {Lecture?.videos ? (
                <>
                  {currentEssayId && (
                    <>
                      {essayAnswers?.quizDetails ? (
                        <>
                          {isEssayAnswersLoading ? (
                            <div className="h-[450px] flex items-center justify-center">
                              <Spinner />
                            </div>
                          ) : (
                            <div className="quiz-container text-center max-h-[450px]">
                              <h1 className="text-burntBlack font-bold sm:text-28px">
                                {currentEssayName}
                              </h1>
                              <h1 className="sm:text-2xl text-xl font-semibold mb-4">
                                Previous Attempts:
                              </h1>
                              <div className="max-h-[250px] overflow-y-scroll">
                                {essayAnswers?.quizDetails.map((answer) => (
                                  <div key={answer.num_tries}>
                                    <h1 className="font-semibold">
                                      Number of Attempt: {answer.num_tries}
                                    </h1>
                                    <div className="px-5 gap-10 my-4">
                                      <h1 className="font-semibold">
                                        Score: {answer.score}%
                                      </h1>
                                      <h1
                                        className={`font-semibold ${
                                          answer.status === "failed"
                                            ? "text-red-500"
                                            : "text-green-500"
                                        } `}
                                      >
                                        Status: {answer.status}
                                      </h1>
                                      {answer.question.map((question) => (
                                        <div key={answer.num_tries}>
                                          <h1 className="text-xs text-primary font-semibold">
                                            Q. {question.question}
                                          </h1>
                                          <h1 className="text-xs">
                                            A. {question.explanation}
                                          </h1>
                                        </div>
                                      ))}
                                    </div>
                                  </div>
                                ))}
                              </div>
                              <Link to={`/essay-quiz/${currentEssayId}`}>
                                <Button
                                  variant="primary"
                                  className="w-full max-w-[70%] mx-auto mt-4 md:!h-16 !h-12 md:!text-xl !text-sm"
                                >
                                  Take the quiz again
                                </Button>
                              </Link>
                            </div>
                          )}
                        </>
                      ) : (
                        <div className="quiz-container text-center h-[450px] flex flex-col justify-center gap-4">
                          <h1 className="text-burntBlack font-bold sm:text-28px">
                            {currentEssayName}
                          </h1>
                          <h1 className="sm:text-2xl text-xl font-semibold mb-4">
                            You have not attempted this quiz yet
                          </h1>
                          <Link to={`/essay-quiz/${currentEssayId}`}>
                            <Button
                              variant="primary"
                              className="w-full max-w-[70%] mx-auto mt-4 md:!h-16 !h-12 md:!text-xl !text-sm"
                            >
                              Start Quiz
                            </Button>
                          </Link>
                        </div>
                      )}
                    </>
                  )}
                  {currentExamId && (
                    <>
                      {examAnswers ? (
                        <>
                          {isExamAnswersLoading ? (
                            <div className="h-[450px] flex items-center justify-center">
                              <Spinner />
                            </div>
                          ) : (
                            <div className="quiz-container text-center max-h-[450px]">
                              <h1 className="text-burntBlack font-bold sm:text-28px">
                                {currentExamName}
                              </h1>
                              <div className="max-h-[250px] overflow-y-scroll">
                                <h1 className="sm:text-2xl text-xl font-semibold mb-4">
                                  Previous MCQ Attempts:
                                </h1>
                                <div>
                                  {examAnswers?.mcqResponse?.studentAnswers.map(
                                    (answer) => (
                                      <Link
                                        to={`/quiz-answers/${currentExamMCQId}/${answer.num_tries}`}
                                        key={answer.num_tries}
                                      >
                                        <h1 className="font-semibold">
                                          Number of Attempt: {answer.num_tries}
                                        </h1>
                                        <div className="px-5 flex justify-center gap-10 my-4">
                                          <h1 className="font-semibold">
                                            Score: {answer.score}%
                                          </h1>
                                          <h1
                                            className={`font-semibold ${
                                              answer.status === "failed"
                                                ? "text-red-500"
                                                : "text-green-500"
                                            } `}
                                          >
                                            Status: {answer.status}
                                          </h1>
                                        </div>
                                      </Link>
                                    )
                                  )}
                                </div>
                                <h1 className="sm:text-2xl text-xl font-semibold mb-4">
                                  Previous Essay Attempts:
                                </h1>
                                <div>
                                  {examAnswers?.essayResponse?.quizDetails.map(
                                    (answer) => (
                                      <div key={answer.num_tries}>
                                        <h1 className="font-semibold">
                                          Number of Attempt: {answer.num_tries}
                                        </h1>
                                        <div className="px-5 gap-10 my-4">
                                          <h1 className="font-semibold">
                                            Score: {answer.score}%
                                          </h1>
                                          <h1
                                            className={`font-semibold ${
                                              answer.status === "failed"
                                                ? "text-red-500"
                                                : "text-green-500"
                                            } `}
                                          >
                                            Status: {answer.status}
                                          </h1>
                                          {answer.question.map((question) => (
                                            <div key={answer.num_tries}>
                                              <h1 className="text-xs text-primary font-semibold">
                                                Q. {question.question}
                                              </h1>
                                              <h1 className="text-xs">
                                                A. {question.explanation}
                                              </h1>
                                            </div>
                                          ))}
                                        </div>
                                      </div>
                                    )
                                  )}
                                </div>
                              </div>
                              <Link to={`/exam/${currentExamId}`}>
                                <Button
                                  variant="primary"
                                  className="w-full max-w-[70%] mx-auto mt-4 md:!h-16 !h-12 md:!text-xl !text-sm"
                                >
                                  Take the exam again
                                </Button>
                              </Link>
                            </div>
                          )}
                        </>
                      ) : (
                        <div className="quiz-container text-center h-[450px] flex flex-col justify-center gap-4">
                          <h1 className="text-burntBlack font-bold sm:text-28px">
                            {currentExamName}
                          </h1>
                          <h1 className="sm:text-2xl text-xl font-semibold mb-4">
                            You have not attempted this Exam yet
                          </h1>
                          <Link to={`/exam/${currentExamId}`}>
                            <Button
                              variant="primary"
                              className="w-full max-w-[70%] mx-auto mt-4 md:!h-16 !h-12 md:!text-xl !text-sm"
                            >
                              Start Exam
                            </Button>
                          </Link>
                        </div>
                      )}
                    </>
                  )}
                  {currentQuizId && (
                    <>
                      {studentAnswers ? (
                        <>
                          {isAnswersLoading ? (
                            <div className="h-[450px] flex items-center justify-center">
                              <Spinner />
                            </div>
                          ) : (
                            <div className="quiz-container text-center max-h-[450px]">
                              <h1 className="text-burntBlack font-bold sm:text-28px">
                                {currentQuizName}
                              </h1>
                              <h1 className="sm:text-2xl text-xl font-semibold mb-4">
                                Previous Attempts:
                              </h1>
                              <div className="max-h-[250px] overflow-y-scroll">
                                {studentAnswers?.studentAnswers.map(
                                  (answer) => (
                                    <Link
                                      to={`/quiz-answers/${currentQuizId}/${answer.num_tries}`}
                                      key={answer.num_tries}
                                    >
                                      <h1 className="font-semibold">
                                        Number of Attempt: {answer.num_tries}
                                      </h1>
                                      <div className="px-5 flex justify-center gap-10 my-4">
                                        <h1 className="font-semibold">
                                          Score: {answer.score}%
                                        </h1>
                                        <h1
                                          className={`font-semibold ${
                                            answer.status === "failed"
                                              ? "text-red-500"
                                              : "text-green-500"
                                          } `}
                                        >
                                          Status: {answer.status}
                                        </h1>
                                      </div>
                                    </Link>
                                  )
                                )}
                              </div>
                              <Link to={`/quiz/${currentQuizId}`}>
                                <Button
                                  variant="primary"
                                  className="w-full max-w-[70%] mx-auto mt-4 md:!h-16 !h-12 md:!text-xl !text-sm"
                                >
                                  Take the quiz again
                                </Button>
                              </Link>
                            </div>
                          )}
                        </>
                      ) : (
                        <div className="quiz-container text-center h-[450px] flex flex-col justify-center gap-4">
                          <h1 className="text-burntBlack font-bold sm:text-28px">
                            {currentQuizName}
                          </h1>
                          <h1 className="sm:text-2xl text-xl font-semibold mb-4">
                            You have not attempted this quiz yet
                          </h1>
                          <Link to={`/quiz/${currentQuizId}`}>
                            <Button
                              variant="primary"
                              className="w-full max-w-[70%] mx-auto mt-4 md:!h-16 !h-12 md:!text-xl !text-sm"
                            >
                              Start Quiz
                            </Button>
                          </Link>
                        </div>
                      )}
                    </>
                  )}
                  {currentVideoUrl && (
                    <>
                      <div className="video-container border border-primary">
                        {/* <VPlayer
                          source={`https://player.vdocipher.com/v2/?otp=${currentVideoOTP}&playbackInfo=${currentVideoPlayback}`}
                          color="#2058AD"
                        /> */}
                        <iframe
                          src={`https://player.vdocipher.com/v2/?otp=${currentVideoOTP}&playbackInfo=${currentVideoPlayback}`}
                          // src={currentVideoUrl}
                          className="w-full sm:h-[450px] h-[300px] object-cover border-0"
                          // style={{border:0, maxWidth:'100%', position:'absolute', top:0, left:0, height:'300px', width:'100%'}}
                          allow="encrypted-media"
                          allowFullScreen
                        ></iframe>
                      </div>
                    </>
                  )}
                </>
              ) : (
                <div className="h-[450px] max-w-[700px] mx-auto flex flex-col justify-center items-center gap-5 text-primary font-semibold text-2xl">
                  <SadFaceIcon />
                  <h1 className="text-center">
                    Sorry for not showing the content, But you can't watch this
                    lecture content unless you pass all the previous quizzes.{" "}
                  </h1>
                  <p className="text-sm text-gray-300">
                    (We care about your understanding of the course content.)
                  </p>
                </div>
              )}
            </div>
            <div>
              <div className="sm:mt-5 sm:pt-0.5">
                <div className="flex justify-between items-center sm:mb-6 mb-4">
                  <div>
                    <h1 className=" text-burntBlack font-bold sm:text-28px">
                      {Lecture?.title}
                    </h1>
                    {Lecture?.videos && (
                      <h2 className="text-burntBlack font-bold sm:text-xl text-sm">
                        {currentVideoName || lastVideoName}
                      </h2>
                    )}
                  </div>
                  <Button
                    //@ts-expect-error
                    onClick={() => mutate(currentVideoId)}
                    variant="primary"
                    className="!h-10 !text-base w-[150px]"
                  >
                    {" "}
                    Watched <EyeFill className="ml-4" />
                  </Button>
                </div>
                <div className="md:block hidden">
                  <h1 className="sm:mb-6 mb-4 text-burntBlack font-bold sm:text-xl">
                    This course includes :
                  </h1>
                  <div className=" md:flex md:divide-x-2 justify-start items-center md:space-y-0 space-y-4 lg:w-full flex-wrap gap-5">
                    <div className="flex items-center gap-2.5">
                      <Video2Icon className="size-6" />{" "}
                      <span className="text-lightGray">
                        Hours on-demand video
                      </span>
                    </div>
                    <div className="flex items-center gap-2.5  md:pl-4">
                      <VerifyIcon className="size-6" />{" "}
                      <span className="text-lightGray">
                        All features access
                      </span>
                    </div>
                    <div className="flex items-center gap-2.5 md:pl-4">
                      <CertificateIcon className="size-6" />{" "}
                      <span className="text-lightGray">
                        Certificate of compilation
                      </span>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>

          <div>
            <div className="lg:w-[409px] lg:mr-9">
              {!isProgressLoading && (
                <>
                  <p className="sm:mb-3 mb-2.5 sm:pb-0.5 text-lightGray tracking-[0.02em] text-sm sm:text-lg font-medium">
                    Your progress -{" "}
                    {isNaN(parseFloat(`${Progress?.percentage}`))
                      ? 0
                      : parseFloat(`${Progress?.percentage}`).toFixed(2)}
                    %
                  </p>
                  <div className="lg:w-[409px] h-2.5 rounded-[30px] bg-[#D9D9D9] overflow-hidden mb-5 sm:mb-6">
                    <div
                      style={{
                        width: `${
                          isNaN(parseFloat(`${Progress?.percentage}`))
                            ? 0
                            : parseFloat(`${Progress?.percentage}`).toFixed(2)
                        }%`,
                      }}
                      className="bg-primary h-full"
                    ></div>
                  </div>
                </>
              )}

              <h1 className="sm:mb-3 mb-2.5 text-burntBlack tracking-[0.02em] font-bold text-lg sm:text-2xl">
                Course Content
              </h1>
              <div className="bg-[#F5F5F5] h-12 sm:h-[60px] rounded-lg px-3 flex items-center justify-between">
                <span className="font-medium sm:text-base text-xs text-lightGray">
                  {totalModules} Modules - {totalLectures} Lesson
                </span>
                <div className="font-medium sm:text-base text-xs text-lightGray flex items-center gap-1.5">
                  <DurationIcon className="sm:size-auto size-[14px]" />
                  {formattedDuration} Hours Total
                </div>
              </div>
            </div>
            <div className="space-y-4 max-h-[620px] overflow-y-scroll overflow-x-hidden pr-5 scrollbar bg-white">
              {Lecture?.chapter?.map((chapter, index) => (
                <Disclosure
                  key={`chapter-${index}`}
                  defaultOpen={chapter?.id === Lecture?.chapterId}
                >
                  {({ open }) => (
                    <div>
                      <Disclosure.Button
                        className={`relative border-b py-4 items-center gap-4 flex w-full justify-between text-left font-semibold  text-sm sm:text-lg duration-300 transition-all ease-in-out  ${
                          open
                            ? "text-primary border-transparent"
                            : "text-burntBlack border-[#D0D5DD]"
                        }`}
                      >
                        <span>{chapter?.name}</span>
                        <div className="flex justify-center items-center gap-4">
                          <p className="text-sm">
                            {formatDuration(Number(chapter?.duration)) ||
                              "00:00"}
                          </p>
                          <Chevron
                            width={24}
                            height={24}
                            className={`!text-inherit sm:size-auto size-[18px] transition duration-300 ease-in-out ${
                              open
                                ? "rotate-[270deg] text-primary"
                                : "rotate-90 text-burntBlack"
                            }`}
                          />
                        </div>
                      </Disclosure.Button>
                      <Transition
                        show={open}
                        enter="transition duration-300 ease-out"
                        enterFrom="transform scale-95 opacity-0"
                        enterTo="transform scale-100 opacity-100"
                        leave="transition duration-150 ease-out"
                        leaveFrom="transform scale-100 opacity-100"
                        leaveTo="transform scale-95 opacity-0"
                      >
                        <Disclosure.Panel className="bg-white">
                          <Accordion
                            type="single"
                            collapsible
                            className="w-full ml-4"
                            defaultValue={activeLectureItemId}
                          >
                            {chapter?.lectures?.map((lecture, lectureIndex) => (
                              <ContentAccordion
                                lectureTime={
                                  formatDuration(Number(lecture?.duration)) ||
                                  "00:00"
                                }
                                onExamSelect={handleExamSelect}
                                onEssaySelect={handleEssaySelect}
                                onQuizSelect={handleQuizSelect}
                                data={Lecture}
                                onVideoSelect={handleVideoSelect}
                                lectureName={lecture?.title}
                                itemId={`lecture-${index}-${lectureIndex}`}
                                onClick={() => handleLectureClick(lecture?.id)}
                                isActive={lectureId === lecture?.id}
                                activeQuizUrl={currentQuizId}
                                activeVideoUrl={currentVideoUrl}
                                activeEssayUrl={currentEssayId}
                                activeExamUrl={currentExamId}
                                key={lectureIndex}
                              />
                            ))}
                          </Accordion>
                        </Disclosure.Panel>
                      </Transition>
                    </div>
                  )}
                </Disclosure>
              ))}
            </div>
          </div>
        </div>

        <div className="block md:hidden mt-10">
          <h1 className="md:mb-6 mb-4 text-burntBlack font-bold md:text-2xl">
            This course includes :
          </h1>
          <div className=" md:flex md:divide-x-2 justify-between items-center md:space-y-0 space-y-4 lg:w-[125%]">
            <div className="flex items-center gap-2.5">
              <Video2Icon className="size-6" />{" "}
              <span className="text-lightGray">Hours on-demand video</span>
            </div>
            <div className="flex items-center gap-2.5  md:pl-4">
              <VerifyIcon className="size-6" />{" "}
              <span className="text-lightGray">All features access</span>
            </div>
            <div className="flex items-center gap-2.5 md:pl-4">
              <CertificateIcon className="size-6" />{" "}
              <span className="text-lightGray">Certificate of compilation</span>
            </div>
          </div>
        </div>
        <form className="mt-5" onSubmit={handleFeedbackSubmit}>
          <h1 className="md:mb-6 mb-4 text-burntBlack font-bold md:text-2xl">
            Write your feedback about this lecture?.
          </h1>
          <TextArea
            placeholder="Feedback"
            name="message"
            value={feedbackMessage}
            onChange={(e) => setFeedbackMessage(e.target.value)}
          />
          <Button
            type={ButtonTypes.SUBMIT}
            variant="primary"
            className="!h-10 !text-base w-[150px] mt-3"
          >
            Send Feedback
          </Button>
        </form>
        <div className="md:pt-12 pt-10 md:mt-16 mt-10 border-t">
          <div className="flex justify-between items-center flex-wrap gap-10">
            <div className="flex items-center sm:gap-4 gap-2.5">
              <div className="sm:size-[100px] size-12 rounded-full overflow-hidden border border-black/20">
                <img
                  className="object-cover object-[25%_75%] "
                  src={Lecture?.instructor.photo}
                  alt="Instructor"
                />
              </div>
              <div className="text-burntBlack">
                <h1 className="mb-0.5 sm:text-2xl font-bold">
                  Dr. {Lecture?.instructor.firstName}{" "}
                  {Lecture?.instructor.lastName}
                </h1>
                <p className="text-lightGray font-medium sm:text-xl tracking-[0.02em]">
                  Instructor
                </p>
              </div>
            </div>
            <Link
              className="bg-[#F5F5F5] rounded-lg px-6 py-2.5 text-lightGray hover:bg-burntBlack hover:text-white duration-300 transition-all ease-in-out font-semibold text-lg sm:w-auto w-full text-center"
              to={`/instructor/${Lecture?.instructor.id}`}
            >
              View Profile
            </Link>
          </div>
        </div>
      </div>
    </div>
  );
};
export default Lecture;
